import "./addTodo.scss";
import {useEffect, useState} from "react";
import { toast } from "react-toastify";
import { FaToEnDigits } from "../../utils/faToEnDigits";
import { AddTodo } from "../../services/todoService";
import Button from "../button/button";
import IconButton from "../iconButton/iconButton"
import DateChooser from "../dateChooser/dateChooser";
import PrioritySelector from "../prioritySelector/prioritySelector";
import AddTodoIcon from "../../assets/images/todoPassive.svg";
import EnterIcon from "../../assets/images/enter.svg";
import CloseIcon from "../../assets/images/closeCancel.svg";
export default function AddTodoComponenet({currentDate, afterAddTodo, onClose}) {
  const [task, setTask] = useState("");
  const [loading, setLoading] = useState(false);
  const [priority, setPriority] = useState(2);
  const [dueDate, setDueDate] = useState(currentDate);
  const date = FaToEnDigits(dueDate.format("YYYYMMDD"));
  
  useEffect(() => {
    setDueDate(currentDate);
  }, [currentDate]);

  function handleAddTodo(e) {
    setTask(e.target.value);
  }

  const handleEnter = (e) => {
    if(e.key === "Enter") {
      e.preventDefault();
      addTodo();
    }
    if (e.key === "Escape") {
      e.preventDefault();
      onClose();
    }
  }

  const addTodo =  async () => {
    if (task !== "") {
      try {
        setLoading(true);
        await AddTodo(task, date, priority);
        setLoading(false);
        setTask("");
        afterAddTodo();
      } catch (err) {
        setLoading(false);
        toast.error(err.error, { toastId: "error" });
      }
    }
  }

  return (
    <div className="addTodo actionWrapper">
      <IconButton icon={CloseIcon} tooltip="بیخیال" onClick={onClose} className="closeIcon" />
      <img src={AddTodoIcon} alt="icon" className="notMobile" />
      <div className="addTodoActions">
        <input
          className= "addTodoInput"
          type="text"
          onChange={(e) => handleAddTodo(e)}
          onKeyDown = {e=>handleEnter(e)}
          placeholder="کاری که باید انجام بدی رو اینجا بنویس"
          value={task}
          autoFocus
        />
        <div className="dueDateOptions">
          <DateChooser label="تاریخ انجام:" date={dueDate} setDate={setDueDate} minDate={0} />
          <PrioritySelector priority={priority} onSelect={(priority) => setPriority(priority)} />
        </div>
        <Button text="ثبت"  onClick={() => addTodo()} className="center notDesktop" width={100} />
      </div>
      <IconButton icon={EnterIcon} loading={loading} tooltip="ثبت" onClick={() => addTodo()} className="notMobile" />
    </div>
  );
}
